import { useEffect } from "react";
import type { Block, ParagraphData, TextPart } from "../../../../models/ManualAuthoring";
import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import StructuredInlineTextEditor from "../editor/StructuredInlineTextEditor";
import "./paragraph.css"

export default function ParagraphEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as ParagraphData;

 return (
    <div className="pdf-block">
      <StructuredInlineTextEditor
        textParts={data.textParts}
        onChange={(newParts) =>
          updateBlock(block.id, { textParts: newParts })
        }
        onDone={onDone}
      />
    </div>
  );
  /*
  useEffect(() => {
    if (!data.textParts || data.textParts.length === 0) {
      updateBlock(block.id, { textParts: [{ type: "text", value: "" }] });
    }
  }, [block.id, data.textParts, updateBlock]);

  const updateTextPart = (index: number, value: string) => {
    const updated: TextPart[] = [...(data.textParts || [])];

    if (updated[index].type === "text") {
      updated[index] = { type: "text", value };
    }

    updateBlock(block.id, { textParts: updated });
  };

  return (
    <div className="pdf-block pdf-paragraph-edit">
      {(data.textParts || []).map((part, index) => {
        if (part.type === "text") {
          return (
            <input
              key={index}
              className="inline-text-edit"
              value={part.value}
              onChange={(e) =>
                updateTextPart(index, e.target.value)
              }
              onBlur={onDone}
            />
          );
        }

        return (
          <span key={index} className="pdf-ref-edit">
            [{part.label ?? part.targetId}]
          </span>
        );
      })}
    </div>
  );
  */
}
